import React from "react";
import { Navigate } from "react-router-dom";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Crearsolvencias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redireccionar: false,
            placa: "",
            tipo: "",
            tiposPlaca: [],
            modelo: "",
            marca: "",
            color: "",
            propietario: "",
            dpi: "",
            nit: "",
            mensajePlaca: "",
            puedeGenerar: false
        };
    }

    componentDidMount() {
        this.cargarTiposPlaca();
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    cargarTiposPlaca = () => {
        fetch(api + "tipos-placa", {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then(datosRespuesta => {
            this.setState({
                tiposPlaca: Array.isArray(datosRespuesta) ? datosRespuesta : []
            });
        })
        .catch(error => {
          
            this.setState({ tiposPlaca: [] });
        });
    };

    verificarPlaca = () => {
        const { placa, tipo } = this.state;

        if (placa.trim() === "" || tipo === "") {
            return;
        }

        fetch(api + "solvencias/verificar?placa=" + placa + "&tipo=" + tipo, {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            if (datos.tieneMultaVigente) {
                this.setState({
                    mensajePlaca: "⚠️ Esta placa tiene multas vigentes. No se puede generar solvencia.",
                    puedeGenerar: false
                });
            } else {
                if (datos.encontrado && datos.datos) {
                    this.setState({
                        modelo: datos.datos.modelo || "",
                        marca: datos.datos.marca || "",
                        color: datos.datos.color || "",
                        propietario: datos.datos.propietario || "",
                        dpi: datos.datos.dpi || "",
                        nit: datos.datos.nit || "",
                        mensajePlaca: "✅ Vehículo encontrado sin multas vigentes. Datos cargados automáticamente.",
                        puedeGenerar: true
                    });
                } else {
                    this.setState({
                        modelo: "",
                        marca: "",
                        color: "",
                        propietario: "",
                        dpi: "",
                        nit: "",
                        mensajePlaca: "✅ Vehículo no registrado. Puede ingresar los datos manualmente.",
                        puedeGenerar: true
                    });
                }
            }
        })
        .catch(error => {
          
            this.setState({
                mensajePlaca: "Error al verificar la placa.",
                puedeGenerar: false
            });
        });
    };

    abrirPDFSolvencia = async (id) => {
        try {
            const respuesta = await fetch(api + `reportes/solvencias/${id}/imprimir`, {
                method: "GET",
                headers: authHeaders()
            });

            if (!respuesta.ok) {
                const error = await respuesta.text();
              
                alert("No se pudo imprimir la solvencia.");
                return;
            }

            const blob = await respuesta.blob();
            const fileURL = window.URL.createObjectURL(blob);

            window.open(fileURL, "_blank");

        } catch (error) {
            
            alert("Error al imprimir la solvencia.");
        }
    };

    guardarSolvencia = () => {
        const usuario = JSON.parse(localStorage.getItem("usuario"));

        const datos = {
            placa: this.state.placa,
            tipo: this.state.tipo,
            modelo: this.state.modelo,
            marca: this.state.marca,
            color: this.state.color,
            propietario: this.state.propietario,
            dpi: this.state.dpi,
            nit: this.state.nit,
            idusuario: usuario.idusuario
        };

        fetch(api + "solvencias", {
            method: "POST",
            headers: authHeaders(),
            body: JSON.stringify(datos)
        })
        .then(respuesta => respuesta.json())
        .then(respuesta => {
            if (respuesta.success) {
                this.abrirPDFSolvencia(respuesta.idsolvencia);

                alert("Solvencia generada correctamente");

                this.setState({
                    redireccionar: true,
                    placa: "",
                    tipo: "",
                    modelo: "",
                    marca: "",
                    color: "",
                    propietario: "",
                    dpi: "",
                    nit: "",
                    mensajePlaca: "",
                    puedeGenerar: false
                });
            } else {
                alert(respuesta.mensaje || "Error al generar solvencia");
            }
        })
        .catch(error => {
            
            alert("Error al conectar con el servidor.");
        });
    };

    render() {
        if (this.state.redireccionar) {
            return <Navigate to="/listarsolvencias" />;
        }

        return (
            <div className="card">
                <div className="card-header">
                    <h4 className="mb-0">Crear solvencia vehicular</h4>
                </div>

                <div className="card-body">
                    <h5>Datos del vehículo</h5>

                    <div className="row mb-3">
                        <div className="col-md-2">
                            <label>Placa</label>
                            <input
                                type="text"
                                name="placa"
                                className="form-control"
                                value={this.state.placa}
                                onChange={this.cambioValor}
                                onBlur={this.verificarPlaca}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>Tipo de placa</label>
                            <select
                                name="tipo"
                                className="form-select"
                                value={this.state.tipo}
                                onChange={this.cambioValor}
                                onBlur={this.verificarPlaca}
                            >
                                <option value="">Seleccione</option>
                                {this.state.tiposPlaca.map((item) => (
                                    <option key={item.idtipoplaca} value={item.idtipoplaca}>
                                        {item.tipo}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-2">
                            <label>Modelo</label>
                            <input
                                type="text"
                                name="modelo"
                                className="form-control"
                                value={this.state.modelo}
                                onChange={this.cambioValor}
                            />
                        </div>

                        <div className="col-md-2">
                            <label>Marca</label>
                            <input
                                type="text"
                                name="marca"
                                className="form-control"
                                value={this.state.marca}
                                onChange={this.cambioValor}
                            />
                        </div>

                        <div className="col-md-2">
                            <label>Color</label>
                            <input
                                type="text"
                                name="color"
                                className="form-control"
                                value={this.state.color}
                                onChange={this.cambioValor}
                            />
                        </div>
                    </div>

                    <small className="text-muted">
                        {this.state.mensajePlaca}
                    </small>

                    <h5 className="mt-4">Datos del propietario</h5>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label>Nombre completo</label>
                            <input
                                type="text"
                                name="propietario"
                                className="form-control"
                                value={this.state.propietario}
                                onChange={this.cambioValor}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>DPI</label>
                            <input
                                type="text"
                                name="dpi"
                                className="form-control"
                                value={this.state.dpi}
                                onChange={this.cambioValor}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>NIT</label>
                            <input
                                type="text"
                                name="nit"
                                className="form-control"
                                value={this.state.nit}
                                onChange={this.cambioValor}
                            />
                        </div>
                    </div>

                    <div className="text-end">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.guardarSolvencia}
                            disabled={!this.state.puedeGenerar}
                        >
                            Generar solvencia
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crearsolvencias;